import { Component, EventEmitter, Input, OnInit, Output, Optional } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { IonIcon, ModalController } from '@ionic/angular/standalone';
import { NavController } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'super-back-button',
  templateUrl: './super-back-button.component.html',
  styleUrls: ['./super-back-button.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonIcon,
    SexyModule,
  ],
})
export class SuperBackButtonComponent implements OnInit {

  @Input() modalController: ModalController = null;
  @Input() icon: string = null;
  @Input() color: string = 'dark';
  @Input() text: string = null;
  @Input() defaultRoute: string = null;
  @Input() action: () => void | Promise<void> = null;
  @Output() onBack: EventEmitter<void> = new EventEmitter();

  private _defaultIcon: string = 'chevron-back-outline';
  private _defaultModalIcon: string = 'close-outline';
  private _defaultText: string = 'Back';
  private _defaultModalText: string = 'Close';

  constructor(
    @Optional() private navController: NavController,
    @Optional() private location: Location
  ) { }

  ngOnInit() {
    // Set default icon based on modalController presence if icon not explicitly set
    if (!this.icon) {
      this.icon = this.modalController ? this._defaultModalIcon : this._defaultIcon;
    }
    // Set default text only if not modalController and text not explicitly set
    // For modals, no text is shown by default
    if (!this.text && !this.modalController) {
      this.text = this._defaultText;
    }
  }

  get displayIcon(): string {
    return this.icon || (this.modalController ? this._defaultModalIcon : this._defaultIcon);
  }

  async handleBack() {

    if (this.modalController) {
      this.modalController.dismiss();
      return;
    }

    // If custom action is provided, use it (parent handles navigation)
    if (this.action) {
      await this.action();
      this.onBack.emit();
      return;
    }

    // Emit event so parent can handle it if needed
    this.onBack.emit();

    // Try NavController first (Ionic navigation)
    if (this.navController) {
      this.navController.back();
      return;
    }

    // Fallback to Location service
    if (this.location) {
      this.location.back();
      return;
    }

    // If defaultRoute is provided, navigate to it
    if (this.defaultRoute) {
      window.location.href = this.defaultRoute;
    }
  }
}
